import React, { lazy, Suspense } from "react";
import { Route, BrowserRouter as Router, Routes, useLocation, Navigate } from "react-router-dom";
import Footer from "./components/footer/Footer";
import Header from "./components/header/Header";
import RSVPComponent from "./components/rsvp/rsvp";
import ScrollToTop from "./components/ScrollToTop";
import Accommodation from "./pages/accomodation/Accommodation";
import FAQ from "./pages/faq/FAQ";
import Home from "./pages/home/Home";
import Registry from "./pages/registry/Registry";
import Login from "./pages/Login";
import NotFound from "./pages/NotFound/NotFound";
import Photos from "./pages/photos/Photos";
import "./styles/styles.css";
import ProtectedRoute from "./ProtectedRoute";
import { AuthProvider } from "./contexts/AuthContext";

// Admin pages pull in heavy export libraries (jspdf, html2canvas), so they're loaded
// on demand instead of being part of the bundle every guest downloads.
const GuestList = lazy(() => import("./pages/GuestList"));
const SeatingPlan = lazy(() => import("./pages/SeatingPlan/SeatingPlan"));

const AppContent: React.FC = () => {
  const location = useLocation();
  const isLoginPage = location.pathname === "/login";
  const isAdminPage = location.pathname.startsWith("/admin");

  return (
    <>
      <ScrollToTop />
      {!isLoginPage && <Header autoHide={location.pathname === "/photos"} />}
      {!isLoginPage && !isAdminPage && <RSVPComponent className="mobileRSVP"/>}
      <div className={isLoginPage ? "" : "content"}>
        <Suspense fallback={<p style={{ textAlign: "center", padding: "2rem" }}>Loading...</p>}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/accommodation" element={<Accommodation />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/registry" element={<Registry />} />
            <Route path="/photos" element={<Photos />} />
            <Route path="/login" element={<Login />} />
            <Route path="/access" element={<Navigate to="/login" replace />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <GuestList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/seating-plan"
              element={
                <ProtectedRoute>
                  <SeatingPlan />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </div>
      {!isLoginPage && <Footer />}
    </>
  );
};

const App: React.FC = () => {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
};

export default App;
